import { render, staticRenderFns } from "./ArrivalPanel.vue?vue&type=template&id=79bd7c7f&scoped=true&"
import script from "./ArrivalPanel.vue?vue&type=script&lang=js&"
export * from "./ArrivalPanel.vue?vue&type=script&lang=js&"
import style0 from "./ArrivalPanel.vue?vue&type=style&index=0&id=79bd7c7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bd7c7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79bd7c7f')) {
      api.createRecord('79bd7c7f', component.options)
    } else {
      api.reload('79bd7c7f', component.options)
    }
    module.hot.accept("./ArrivalPanel.vue?vue&type=template&id=79bd7c7f&scoped=true&", function () {
      api.rerender('79bd7c7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/queuePopup/ArrivalPanel.vue"
export default component.exports